'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.ViewportLegend', []).directive('rmViewportLegend', require('./directives/ViewportLegendDirective'));